/**
 * @packageDocumentation
 * @module HackerAPI.Company
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../hackerapi-fetch/hackerapi-fetch";
import Base from "../base/base";
import { parseDate } from "../utils/utils";
/**
 * A data container for company data
 * @struct
 * @extends { HackerAPI.Base }
 */
var Company = /** @class */ (function (_super) {
    __extends(Company, _super);
    /**
     * Instantiates a new Company instance
     * @constructor
     * @param company
     */
    function Company(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, website = _b.website, twitter = _b.twitter, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * The company's ID
         * @type { number }
         */
        _this.id = id;
        /**
         * The company's name
         * @type { string }
         */
        _this.name = name;
        /**
         * The company's website
         * @type { string }
         */
        _this.website = website;
        /**
         * The company's twitter
         * @type { string }
         */
        _this.twitter = twitter;
        /**
         * When the company was created in the database
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the company was last updated in the database
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Fetches a company from hackerapi
     * @param company
     * @returns
     */
    Company.fetch = function (_a) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/companies/" + id,
            method: "GET"
        }).then(function (data) { return new Company(data); });
    };
    /**
     * Creates a company on hackerapi
     * @param company
     * @returns
     */
    Company.create = function (company) {
        return HackerAPIFetch({
            path: "/v2/companies",
            method: "POST",
            body: company.toHackerAPIFormat()
        }).then(function (data) { return new Company(data); });
    };
    /**
     * Updates a company on hackerapi
     * @param company
     * @param [auth]
     * @param [auth.token]
     * @returns
     */
    Company.update = function (company, token) {
        return HackerAPIFetch({
            path: "/v2/companies",
            method: "POST",
            token: token,
            body: company.toHackerAPIFormat()
        }).then(function (data) { return new Company(data); });
    };
    return Company;
}(Base));
export default Company;
//# sourceMappingURL=company.js.map